import React from 'react';

const FetchContext = React.createContext<{
  query: (query: string, variables: Record<string, unknown>) => any;
}>({ query: () => null });
FetchContext.displayName = 'FetchContext';

export default FetchContext;
